import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DataFormatService {
  constructor() { }

  currencyFormat(): object {
    return { type: 'currency', precision: 2 };
  }
}
